import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
//import App from './App'

import { addLocaleData } from 'react-intl';

import Home from './Login/Home';
import OTP from './Login/OTP';
import Email from './Login/Email';
import { trackPageView } from '../utils/tracker';

import ConnectedIntlProvider from '../store/ConnectedIntlProvider';
import thLocaleData from 'react-intl/locale-data/th';
addLocaleData(thLocaleData);

const Root = ({ store }) => (
  <Provider store={store}>
    <ConnectedIntlProvider>
      <BrowserRouter basename="/sso-hrportal">
        <Switch>
          <Route exact path="/" component={withTracker(Home)} />
          <Route exact path="/email" component={withTracker(Email)} />
          <Route path="/OTP" component={withTracker(OTP)} />
        </Switch>
      </BrowserRouter>
    </ConnectedIntlProvider>
  </Provider>
);

const withTracker = WrappedComponent => {
  const HOC = props => {
    trackPageView();

    return <WrappedComponent {...props} />;
  };

  return HOC;
};

export default Root;
